import vatExemptDiscount, { isVatExemptPrivilege, round2 } from "../vatExempt";

const individual = (menu, privilege = 0) => {
  const { srp = 0, qty = 1, discountable = false } = menu;
  const gross = srp * qty;
  const hasPrivilegeDiscount = Number(privilege || 0) > 0 && discountable;

  // PWD / Senior / Indigenous: VAT removed first, then 20% (per unit)
  if (hasPrivilegeDiscount && isVatExemptPrivilege(privilege)) {
    const { up, vat, vatExempt, lessDiscount } = vatExemptDiscount(srp);
    const discount = round2(gross - up * qty);

    return {
      gross,
      up,
      discount,
      net: round2(gross - discount),
      vat: round2(vat * qty),
      vatExempt: round2(vatExempt * qty),
      lessDiscount: round2(lessDiscount * qty),
    };
  }

  const up = hasPrivilegeDiscount ? Math.round((srp * 80) / 100) : srp;
  const discount = gross - up * qty;

  return {
    gross,
    up,
    discount,
    net: gross - discount,
  };
};

const computeCP = (menu, privilege = 0) => {
  if (!Array.isArray(menu)) return individual(menu, privilege);

  const accumulator = {
    gross: 0,
    discount: 0,
    vat: 0,
    vatExempt: 0,
    lessDiscount: 0,
  };

  // gross of the discountable (PWD / Senior / Indigenous) items, the rest is fixed price
  let exemptGross = 0;

  for (const item of menu) {
    const { gross = 0, discount = 0, vat = 0 } = individual(item, privilege);
    accumulator.gross += gross;
    if (vat > 0) exemptGross += gross;
    else accumulator.discount += discount;
  }

  // VAT and 20% taken once from the discountable subtotal, not summed per item
  const { vat, vatExempt, lessDiscount } = exemptGross
    ? vatExemptDiscount(exemptGross)
    : { vat: 0, vatExempt: 0, lessDiscount: 0 };

  // only the amount due is rounded to whole pesos, discount absorbs the centavos
  const net = Math.round(accumulator.gross - accumulator.discount - lessDiscount);

  return {
    gross: accumulator.gross,
    discount: accumulator.gross - net,
    vat,
    vatExempt,
    lessDiscount,
    net,
  };
};

export default computeCP;
